module.exports = __webpack_public_path__ + "static/media/13-mobile.b59bd01a.webp";